import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import visionLogo from "../assets/img/logo-vision.png";
import { IoMdLogOut } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import RequestService from "../services/RequestService";
import NewRequestModal from './../components/modals/NewRequestModal';
import { Context } from '../context/UserContext'
import { GrDeliver } from "react-icons/gr";
import { BsChatRightTextFill } from "react-icons/bs";
import SupportModal from "../components/modals/SupportModal";


export default function SidebarTecnico() {

    const location = useLocation();
    const [newRequestModal, setNewRequestModal] = useState(false);
    // const [gestaoQuantidade, setGestaoQuantidade] = useState()
    const [isCollapsed, setIsCollapsed] = useState(true);

    const [supportModal, setSupportModal] = useState(false);

    const { logout, user, authenticated } = useContext(Context)

    const handleNewRequest = async () => {
        setNewRequestModal(true)
    }

    const handleSupport = async () => {
        setSupportModal(true)
    }

    // useEffect(() => {


    //     // A cada 5 seg
    //     const intervalId = setInterval(async () => {
    //         const status = '?status=GESTAO';
    //         const requestsGestao = await RequestService.getRequest(status);
    //         console.log(requestsGestao.requests.length)
    //         setGestaoQuantidade(requestsGestao.requests.length);
    //     }, 10000); // 5000 milissegundos = 5 segundos

    //     // Limpa o intervalo quando o componente for desmontado
    //     return () => clearInterval(intervalId);
    // }, []);

    return (
        <div className="flex flex-col justify-center items-center shadow h-full z-10 bg-white" 
            onMouseOver={() => setIsCollapsed(false)} 
            onMouseOut={() => setIsCollapsed(true)}
        >

            <div className="flex justify-center items-center w-full h-36">
                <img className={`mx-auto ${isCollapsed ? 'h-6 rotate-90' : 'h-12'} w-auto`} src={visionLogo} alt="Vision logo" />
            </div>

            {/* <button onClick={() => setIsCollapsed(!isCollapsed)} className="flex top-4 right-4 bg-red-200 p-2 rounded">
                {isCollapsed ? 'Expand' : 'Collapse'}
            </button> */}

            <div className={`flex flex-1 ${isCollapsed ? 'w-full' : 'w-52'} left-0 flex-col justify-start items-start gap-1`}>

                <Link className="w-full h-12 relative hover:bg-indigo-100" onClick={handleNewRequest}>
                    <div className={`w-full h-12 left-0 top-0 absolute`} />
                    <div className="w-6 h-6 left-[18px] top-[12px] absolute">
                        <FaPlus size={25} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[14px] absolute text-neutral-900 text-sm">Nova Solicitação</span>}
                </Link>

                <Link to="/app/myrequests" className="w-full h-6 relative hover:bg-indigo-100">
                    <div className={`w-full h-6 left-0 top-0 absolute ${location.pathname === '/app/myrequests' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[5px] absolute">
                        <CiBoxList size={17} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[6px] absolute text-neutral-900 text-xs">Minhas Solicitações</span>}
                </Link>

                <Link to="/app/myreverses" className="w-full h-6 relative hover:bg-indigo-100">
                    <div className={`w-full h-6 left-0 top-0 absolute ${location.pathname === '/app/myreverses' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[5px] absolute">
                        <GrDeliver size={17}/>
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[6px] absolute text-neutral-900 text-xs">Minhas Coletas</span>}
                </Link>

                {/* <div className="w-full h-[0px] border mt-4 border-zinc-200"></div> */}

            </div>

            <div className={`flex flex-2 mb-2 ${isCollapsed ? 'w-full' : 'w-52'} left-0 flex-col justify-start items-start gap-1 sticky bottom-0 float-end`}>

                <Link className="w-full h-8 bg-gray-600 text-white relative hover:bg-indigo-500 flex items-center justify-center" onClick={handleSupport}>
                    <div className="flex items-center">
                        <BsChatRightTextFill size={15} />
                        {!isCollapsed && <span className="ml-2 text-sm">Suporte</span>}
                    </div>
                </Link>

                <div className="w-full h-[0px] border border-zinc-200" />

                <button onClick={logout} className="w-full h-12 relative hover:bg-indigo-100">
                    <div className="w-6 h-6 left-[18px] top-[12px] absolute">
                        <IoMdLogOut size={25} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[14px] absolute text-neutral-900 text-sm">Sair</span>}
                </button>

            </div>

            { user && authenticated &&
                <div className='absolute'>
                    <NewRequestModal
                        isModalOpen={newRequestModal}
                        setModalOpen={() => {
                            setNewRequestModal(!newRequestModal)
                        }}
                        user={user}
                        // ticketId={ticketOnModal}
                        // setTicketCb={setTicket}
                    ></NewRequestModal>

                    <SupportModal
                        isModalOpen={supportModal}
                        setModalOpen={() => {
                            setSupportModal(!supportModal)
                        }}
                    ></SupportModal>
                </div>
            }

        </div>
    );
}
